<template>
    <div v-if="!object.id" class="mt-8">
        <main-component :object="item" :totalFac="totalFac" @callLoadItem="loadItem" @callRedirectEditItem="redirectEditItem"></main-component>
    </div>
    <div v-else>
        <v-tabs
            v-model="active_tab"
            show-arrows 
        >
            <v-tab href="#tab-1" class="caption"> Principal</v-tab>
            <v-tab href="#tab-2" class="caption"> Colaboradores </v-tab>
            <v-tab href="#tab-3" class="caption"> 
                Imóveis Relacionados   
            </v-tab>
            <v-tab href="#tab-4" class="caption"> Histórico </v-tab>
            <v-tab v-if="item.finalidade == 'Alugar um imóvel' || item.finalidade == 'Comprar um imóvel'" href="#tab-5" class="caption"> 
                Perfil de imóvel 
                <v-chip
                    class="ma-2"
                    x-small
                    color="pink"
                    label
                    dark
                >
                    NOVO
                </v-chip> 
            </v-tab>
            <v-tab v-if="item.finalidade == 'Alugar um imóvel' || item.finalidade == 'Comprar um imóvel'" href="#tab-6" class="caption"> Locais </v-tab>
            <v-tab href="#tab-7" class="caption"> Status </v-tab>
        </v-tabs>
    
        <v-tabs-items v-model="active_tab">
            <v-tab-item value="tab-1">
                <v-card flat class="pa-8">
                    <main-component :object="item" @callLoadItem="loadItem" />
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-2">
                <v-card flat class="pa-8">
                    <colaborator-form :object="colaborators" />
                </v-card>    
            </v-tab-item>
            <v-tab-item value="tab-3">
                <v-card flat class="pa-8">
                    <property-relation-form :object="property_relations" />
                </v-card>    
            </v-tab-item>
            <v-tab-item value="tab-4">
                <v-card flat class="pa-8">
                    <comment-form :object="comments" />
                </v-card>    
            </v-tab-item>
            <v-tab-item value="tab-5">
                <v-card flat class="pa-8">
                    <property-profile-component :object="item.property_profiles" :fac="item" />
                </v-card>    
            </v-tab-item>
            <v-tab-item value="tab-6">
                <v-card flat class="pa-8">
                    <place-form :object="places" />
                </v-card>    
            </v-tab-item>
            <v-tab-item value="tab-7">
                <v-card flat class="pa-8">
                    <status-component :object="item" />
                </v-card>    
            </v-tab-item>
        </v-tabs-items>
    </div>    
</template>


<script>
import MainComponent from './MainComponent.vue';
import ColaboratorForm from '@/components/colaborators/ColaboratorForm.vue'
import PropertyRelationForm from '@/components/property_relations/PropertyRelationForm.vue'
import CommentForm from '@/components/comments/CommentForm.vue'
import PropertyProfileComponent from '@/components/propertyprofiles/PropertyProfileComponent.vue'
import StatusComponent from './StatusComponent.vue'
import ShowComponent from '@/components/properties/show/ShowComponent.vue'
import ButtonShareComponent from '../../button_share/ButtonShareComponent.vue'
import PlaceForm from '@/components/places/PlaceForm.vue'

export default {
    created() {
        this.setTab()
        this.setObject()
    },

    components: {
        MainComponent,
        ColaboratorForm,
        PropertyRelationForm,
        CommentForm,
        PropertyProfileComponent,
        StatusComponent,
        ShowComponent,
        PlaceForm,
        ButtonShareComponent
    },

    mounted(){
        this.countFac();
    },

    props: {
        object: {
            require: false,
        },
    }, 

    computed: {
        me () {
          return this.$store.state.auth.me
        },
    },

    watch: {
        object () {   
            if(this.item.id != this.object.id){
                this.setTab()
            }
            this.setObject()
        },

        options: {
            handler() {
                if(this.options.page >= 1){
                    //this.checkPropertyProfile();
                }   
            },
        },

        filters () {
            this.options.page = 1
        },
    },


    data () {
        return {
            totalFac: 0,
            active_tab: 'tab-1',
            item: {},
            property: {},
            property_items: [],
            total_properties: 0,
            dialog: {
                show: false
            },
            permissions: '',

            colaborators: {
                model: "facs",
                descriptions: ['Atendimento','Recepçāo','Gerente'],
                item_id: "",
                items: []     
            },

            property_relations: {
                model: "facs",
                item_id: "",
                items: []   
            },
            
            comments: {
                model: "facs",
                item_id: "",
                items: []   
            },

            places: {
                model: "facs",
                item_id: "",
                cidade: "",
                estado: "",
                items: []   
            },

            params_check_properties: {
                multiple_status: ['Ativo','Desatualizado'],
                places: [],
                multiple_setor: [],
                cidade1: null,
                cidade2: null
            },

            options: {
                page: 1,
                itemsPerPage: 10,
            },

            headers: [
                { text: 'FOTO', align: 'start', value: 'photo', },
                { text: 'DESCRIÇĀO', align: 'start', value: 'description', },
                { text: 'AÇĀO', value: 'actions', sortable: false },
            ],

        }
    },

    methods: {
        redirectEditItem(id){
            this.$emit('callRedirectEditItem', id)
        },

        loadItem(id){
            this.$emit('callLoadItem', id)
        },
        
        setTab(){
            this.active_tab = 'tab-1'
        },

        checkColaborator(){
            if(this.me.profile != 'Master' && this.me.profile != 'Gerente'){
                if(this.property && this.property.colaborators.length > 0){
                    var access = false
                    this.property.colaborators.forEach(i => {
                        if(i.user_id == this.me.id){
                            access = true
                        }
                    })
                    this.permissions.colaborator = access
                }
            }
        },

        setObject(){
            this.item = this.object
            this.total_properties = 0
            this.property_items = '',

            // colaborators
            this.colaborators.item_id = this.object.id
            this.colaborators.items = this.object.colaborators

            // property_relations
            this.property_relations.item_id = this.object.id
            this.property_relations.items = this.object.property_relations

            // comments
            this.comments.item_id = this.object.id
            this.comments.items = this.object.comments

            // places
            this.places.item_id = this.object.id
            this.places.estado = this.me.branch.estado
            this.places.items = this.object.places    

            if(this.item && (this.item.finalidade == 'Alugar um imóvel' || this.item.finalidade == 'Comprar um imóvel')){
                //this.checkPropertyProfile()
            }
        },

        countFac(){
            this.$store.dispatch('facs_total')
                        .then(response => {
                            this.totalFac = response
                        })
                        .catch(error => {
                            console.log(error)
                            this.$snotify.error('Erro no cadastro')
                        })
        },
        
    },
}
</script>

<style scoped>

</style>